import { forEach, get, keys } from "lodash";
import { useMemo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

const useQueryParams = () => {
  const [currentQueryParameters, setSearchParams] = useSearchParams();
  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);

  const updateQueryParams = (values) => {
    const params = keys(values);
    forEach(params, (param) => query.set(param, get(values, param)));
    setSearchParams(query);
  };

  return {
    query,
    updateQueryParams,
  };
};

export default useQueryParams;
